import  apiClient from "./axiosClient"

/**
 * getSettings
 * @return request
 */
const getSettingsById = (id) => {
  return apiClient.get(`/settings/${id}/edit`)
    .catch(err=>{
        console.log("err ", err);
    });
}

/**
 * getSettings
 * @return request
 */
const getSettings = () => {
  return apiClient.get(`/settings/`)
    .catch(err=>{
        console.log("err ", err);
    });
}

/**
 * getAllSettings
 * @return request
 */
const getAllSettings = () => {
  return apiClient.get(`/settings/all`)
    .catch(err=>{
        console.log("err ", err);
    });
}

/**
 * 
 * @param {Object} data 
 * @return request
 */
const createSettings = (data) => {
  return apiClient.post(`/settings/`, data, {
    headers: {
      "Content-type": "multipart/form-data"
    }
  });
}

/**
 * 
 * @param {Object} data 
 * @return request
 */
const updateSettings = (id, data) => {
  return apiClient.put(`/settings/${id}`, data, {
    headers: {
      "Content-type": "multipart/form-data"
    }
  });
}

const getContent = (path) => {
  return apiClient.get(`/settings/${path}/content`);
}

export { 
  getSettings, 
  getSettingsById, 
  getAllSettings, 
  createSettings, 
  updateSettings,
  getContent
};




